import React from 'react'

interface Props {
  title?: React.ReactNode
  children: React.ReactNode
  img?: string
}

export const ContactCard = ({ title, children, img }: Props) => {
  return (
    <div className="w-full max-w-full p-6 rounded-xl border-8 border-brightgreen md:h-[300px]">
      <div className="flex flex-col items-start gap-6 h-full">
        {img && <img src={img} alt={typeof title === 'string' ? title : 'Contact card image'} className="h-[63px] w-[73px]" />}

        <div className="grid grid-cols-1 gap-4 overflow-hidden">
          <h2 className="text-darkblue text-xl font-bold">{title}</h2>
          {children}
        </div>
      </div>
    </div>
  )
}

ContactCard.displayName = 'ContactCard'
